import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { timer } from 'rxjs';
import { SidenavService } from '../service/sidenav.service';
import { AsideAction, SidenavAction, SidenavSide } from './aside.action';
import { ErrorsAction } from './errors.state';

@State({
    name: 'aside'
})
@Injectable()
export class AsideState {

    constructor(private sidenavService: SidenavService) {
    }

    @Action(AsideAction.Generic)
    save(context: StateContext<any>, action: AsideAction.Generic) {
        this.dispatch(context, action);
        return timer(500);
    }

    @Action(AsideAction.CloseAll)
    closeAll(context: StateContext<any>) {
        this.dispatch(context, new AsideAction.Generic(SidenavSide.LEFT, SidenavAction.CLOSE));
        this.dispatch(context, new AsideAction.Generic(SidenavSide.RIGHT, SidenavAction.CLOSE));
    }

    private dispatch(context: StateContext<any>, sidenav: AsideAction.Generic) {
        if (sidenav.side === SidenavSide.RIGHT) {
            context.dispatch(new ErrorsAction.CleanAside());
        }
        this.sidenavService.dispatch(sidenav);
    }
}
